<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';
import Dropdown from 'primevue/dropdown';

const { idErreur, options, optionLabel, optionGroupLabel, optionGroupChildren, placeholder, showClear, emptyMessage } = defineProps({
    idErreur: String,
    options: Array,
    optionLabel: String,
    optionGroupLabel: String,
    optionGroupChildren: String,
    placeholder: String,
    showClear: Boolean,
    emptyMessage: String
});

const valeur = defineModel('valeur', {
    type: [Object, String]
});

const erreursSaisie = inject('erreursSaisie');

function modifierValeur(val) {
    valeur.value = val;
}

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <Dropdown 
            v-model="valeur" 
            :options="options" 
            :optionLabel="optionLabel"
            :optionGroupLabel="optionGroupLabel"
            :optionGroupChildren="optionGroupChildren"
            :placeholder="placeholder"
            :showClear="showClear"
            :emptyMessage="emptyMessage"
            @update:modelValue="modifierValeur" />
    </Saisie>
</template>

<style scoped>

</style>